module.exports = __webpack_public_path__ + "img/btc.e73cb1b2.svg";